import { render, staticRenderFns } from "./ProvidersData.vue?vue&type=template&id=0ff3cc82"
import script from "./ProvidersData.vue?vue&type=script&lang=js"
export * from "./ProvidersData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports